import { startFileSessionRefresh } from "../libraries/fileAccess";
import { useEffect } from "react";
import { resetPagePageSize } from "@lhd/utility";
import { useAutoCompanyParam } from "@lhd/hooks";
import { useMemo } from "react";

export type Props = Record<string, never>;

const useApp = (props: Props) => {
  useMemo(resetPagePageSize, []);
  useEffect(startFileSessionRefresh, []);
  useAutoCompanyParam();
  return {
    ...props,
  };
};

export type ReceivedProps = ReturnType<typeof useApp>;

export default useApp;
